export default __webpack_public_path__ + "assets/need-invite-bird.04368741fb.png";